import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withKeys as _withKeys, vModelText as _vModelText, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "overflow-x-auto" }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = { class: "flex flex-wrap space-y-2 md:space-x-2 md:flex-nowrap md:space-y-0" }
const _hoisted_4 = { class: "flex w-full md:w-4/5" }
const _hoisted_5 = {
  value: "please-select",
  selected: "",
  disabled: ""
}
const _hoisted_6 = { value: "email" }
const _hoisted_7 = { value: "first_name" }
const _hoisted_8 = { value: "last_name" }
const _hoisted_9 = {
  key: 0,
  value: "organisations"
}
const _hoisted_10 = {
  key: 1,
  value: "sub_organisation"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-search",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" })
], -1)
const _hoisted_12 = { class: "w-full md:w-1/4" }
const _hoisted_13 = { class: "flex flex-wrap space-x-2 md:flex-nowrap" }

import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";

import RoleGuard from "@/components/RoleGuard.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import RouterButton from "@/components/RouterButton.vue";
import UsersTable from "@/components/tables/UsersTable.vue";

import api from "@/api/api";
import { User } from "@/types/User";
import { PaginationMeta } from "@/types";

import { useFilters } from "@/composables/filters";
import { userHasRole } from "@/utils/roles";
import { useUserStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersList',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const router = useRouter();
const userStore = useUserStore();

const meta = ref({} as PaginationMeta);
const users = ref([] as User[]);

/** Search & Filters */
const { filters, getFiltersFromQuery, resetFilters, sortBy, setFilter, filter, setFilterNoRefresh } = useFilters(route);

async function search() {
  const response = await api.users.listUsers(filters.value);

  users.value = response.data.users;
  meta.value = response.meta;
}

getFiltersFromQuery();
;(
  ([__temp,__restore] = _withAsyncContext(() => setFilterNoRefresh("search_type", (route.query.search_type as string) || "please-select"))),
  await __temp,
  __restore()
);
;(
  ([__temp,__restore] = _withAsyncContext(() => search())),
  await __temp,
  __restore()
);

if (userHasRole(userStore.user.roles, ["l4a-trainer", "l4a-trainee"])) {
  router.push({ path: "/error" });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _ctx.$t('users')
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filters).search_type) = $event)),
            class: "block w-48 h-10 py-2 text-gray-900 border border-gray-600 rounded-l"
          }, [
            _createElementVNode("option", _hoisted_5, _toDisplayString(_ctx.$t("please-select")), 1),
            _createElementVNode("option", _hoisted_6, _toDisplayString(_ctx.$t("email")), 1),
            _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.$t("first-name")), 1),
            _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.$t("last-name")), 1),
            (_unref(userStore).userIsAdmin)
              ? (_openBlock(), _createElementBlock("option", _hoisted_9, _toDisplayString(_ctx.$t("trained-by")), 1))
              : _createCommentVNode("", true),
            (_unref(userStore).userIsAdmin)
              ? (_openBlock(), _createElementBlock("option", _hoisted_10, _toDisplayString(_ctx.$t("organisation")), 1))
              : _createCommentVNode("", true)
          ], 512), [
            [_vModelSelect, _unref(filters).search_type]
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "search",
            id: "search",
            onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_unref(filter) && _unref(filter)(...args)), ["enter"])),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(filters).search) = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600",
            placeholder: "Search ...",
            required: ""
          }, null, 544), [
            [_vModelText, _unref(filters).search]
          ]),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(filter) && _unref(filter)(...args))),
            type: "submit",
            class: "flex items-center h-10 px-4 py-2 space-x-2 text-white rounded-r bg-primary hover:bg-blue-700 focus:ring-4 focus:outline-none whitespace-nowrap focus:ring-blue-300"
          }, [
            _hoisted_11,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("search")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(RoleGuard, { roles: ['admin', 'users-admin'] }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(RouterButton, {
                  type: "secondary",
                  loading: false,
                  disabled: false,
                  to: { path: '/dashboard/users/new' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("add-new-user")), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(UsersTable, {
      users: users.value,
      meta: meta.value,
      filters: _unref(filters),
      onSort: _unref(sortBy),
      onFilter: _unref(setFilter),
      onReset: _unref(resetFilters)
    }, null, 8, ["users", "meta", "filters", "onSort", "onFilter", "onReset"])
  ]))
}
}

})